import React, { FunctionComponent, useEffect } from 'react';
import { BackHandler, StyleSheet, Text, View } from 'react-native';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { BackButton } from './BackButton';

interface IProps {
  title: string;
  onBackPress: () => void;
  headerRightComponent?: React.ReactNode;
}

export const DeviceSetupSubScreenHeader: FunctionComponent<IProps> = ({ title, onBackPress, headerRightComponent }) => {
  useEffect(() => {
    const backPressHandler = () => {
      onBackPress();
      return true;
    };

    const backHandler = BackHandler.addEventListener('hardwareBackPress', backPressHandler);

    return () => backHandler.remove();
  }, []);

  return (
    <>
      <View style={[styles.container]}>
        <BackButton onPress={onBackPress} />
        {
          headerRightComponent &&
          <View style={{ flexDirection: 'row' }}>
            <Text style={[styles.text, { flex: 1 }]}>{title}</Text>
            <View style={{ justifyContent: 'flex-end', flexDirection: 'row' }}>
              {headerRightComponent}
            </View>
          </View>
        }
        {
          !headerRightComponent &&
          <Text style={styles.text}>{title}</Text>
        }
      </View>
      <View style={{ alignItems: 'center' }}>
        <View style={styles.horizontalDivider} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    height: defaultScale(45),
    justifyContent: 'center',
  },
  text: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    textAlign: 'center',
  },
  horizontalDivider: {
    height: 1,
    width: '100%',
    backgroundColor: Theme.GREY_MEDIUM,
  },
});
